export async function fetchFormVersions(formId, token) {
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/forms/${formId}/versions`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || "Failed to fetch versions");
  }

  return res.json();
}

export async function restoreVersion(versionId, token) {
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/forms/restore-version`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ versionId })
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || "Failed to restore version");
  }

  return res.json();
}
